// extracted by mini-css-extract-plugin
export var pillWrapper = "_p9-0";
export var showOverflow = "_p9-1";